<style lang="postcss">
	header {
		position: absolute;
		left: 0;
		right: 0;
		z-index: 40;
	}
	header.fixed-header {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		background-color: white;
	}
	header.fixed-header.seamless-header {
		position: absolute;
		background-color: transparent;
	}
	header.seamless-header {
		border-color: transparent;
		background-color: transparent;
	}
	.header-cover {
		margin: 0 auto;
		font-size: 14.75px;
	}
	.main-content:not(.seamless-header) {
		padding-top: 3.5rem;
	}
	.main-content.wide-page {
		max-width: none;
	}
	.header-link {
		position: relative;
		font-weight: 475;
	}
	.header-link:hover {
		-webkit-text-stroke: 0.3px;
		@apply text-gray-800;
	}
	.footer-link {
		font-size: 13px;
		padding: 0.15rem 0;
	}
	.footer-link:hover {
		color: black;
		text-decoration: underline;
	}
	.footer-partner-logo {
		opacity: 0.7;
		filter: grayscale(1);
	}
	.footer-partner-logo:hover {
		opacity: 1;
		filter: grayscale(0);
	}
	@media (min-width: 768px) {
		.main-content,
		.header-cover {
			padding-left: 3rem;
			padding-right: 3rem;
			max-width: 80rem;
		}
		.main-content.wide-page {
			padding-left: 0;
			padding-right: 0;
		}
		.header-link-div {
			position: relative;
			display: flex;
			justify-content: center;
		}
		.header-link-div:hover .sub-menu {
			display: grid;
		}
		.sub-menu {
			position: absolute;
			display: none;
			width: 30rem;
			border-radius: 0.5rem;
			grid-template-columns: repeat(2, minmax(0, 1fr));
			top: 100%;
			background-color: white;
			padding: 0.75rem;
			box-shadow:
				0 0 0 1px rgba(0, 0, 0, 0.75),
				0.1px 0.2px 0.3px hsl(0deg 0% 63% / 0.65),
				0.8px 1.1px 1.5px -0.4px hsl(0deg 0% 63% / 0.65),
				1.4px 2px 2.7px -0.7px hsl(0deg 0% 63% / 0.65),
				2.4px 3.2px 4.5px -1.1px hsl(0deg 0% 63% / 0.65),
				3.8px 5.2px 7.2px -1.4px hsl(0deg 0% 63% / 0.65),
				5.9px 8.1px 11.3px -1.8px hsl(0deg 0% 63% / 0.65),
				8.9px 12.2px 17px -2.1px hsl(0deg 0% 63% / 0.65),
				13.1px 18px 25px -2.5px hsl(0deg 0% 63% / 0.65);
		}
		.footer-text {
			font-size: 13.5px;
			line-height: 1.6;
		}
		.header-link {
			font-weight: 445;
		}
		.header-link.active {
			--tw-text-opacity: 1;
			color: rgb(38 38 38 / var(--tw-text-opacity));
			position: relative;
		}
		.header-link.active a.active {
			text-align: center;
			display: flex;
			justify-content: center;
			-webkit-text-stroke: 0.3px;
		}
		.header-link.active a.active::before {
			content: "";
			display: block;
			position: absolute;
			margin: 0 auto;
			height: 2px;
			width: 10px;
			bottom: 18%;
			border-radius: 10px;
			background-color: rgb(38 38 38 / 1);
		}
	}
	@media (max-width: 768px) {
		header.mobile-nav {
			position: fixed;
			top: 0;
			left: 0;
			width: 100vw;
			border-color: transparent;
			background-color: white;
			z-index: 50;
		}
		.main-content,
		.header-cover {
			padding-left: 1.5rem;
			padding-right: 1.5rem;
		}
		.main-content.wide-page {
			padding-left: 0;
			padding-right: 0;
		}
		.main-content.seamless-mobile {
			padding-left: 0;
			padding-right: 0;
		}
		.header-link {
			width: 100%;
		}
		.footer-text {
			font-size: 15.5px;
			line-height: 1.75;
		}
	}
</style>

<script lang="ts">
	import { browser } from "$app/environment";
	import { page } from "$app/stores";
	import { PUBLIC_APP_URL } from "$env/static/public";
	import Hamburger from "$src/lib/Components/Basic/Hamburger.svelte";
	import LogoPng from "$lib/images/brand/formcrafts-logo-wide@xs.png";
	import SalesforcePartner from "$lib/images/other/salesforce-partner.webp";
	import HubSpotPartner from "$lib/images/other/hubspot-partner.png";
	import "../app.css";
	import { onMount } from "svelte";

	export let data;

	const header = [
		{
			category: "Templates",
			link: "/form-templates",
			links: data.templateCategories
		},
		{
			category: "Features",
			link: "/help/features",
			links: data.features
		},
		{
			category: "Pricing",
			link: "/pricing",
			links: []
		},
		{
			category: "Help",
			link: "/help",
			links: []
		}
	];

	const footer = [
		{
			category: "Templates",
			hideOnMobile: false,
			links: [
				{
					title: "Application forms",
					href: "/form-templates/application-forms"
				},
				{
					title: "Lead generation forms",
					href: "/form-templates/lead-generation-forms"
				},
				{
					title: "Survey & feedback forms",
					href: "/form-templates/survey-and-feedback-forms"
				},
				{ title: "Evaluation forms", href: "/form-templates/evaluation-forms" },
				{
					title: "Support request forms",
					href: "/form-templates/support-request-forms"
				},
				{
					title: "Booking & registration",
					href: "/form-templates/booking-and-registration-forms"
				},
				{ title: "Contact forms", href: "/form-templates/contact-us-forms" }
			]
		},
		{
			category: "Comparisons",
			hideOnMobile: false,
			links: [
				{ title: "vs All", href: "/compare" },
				{ title: "FormAssembly", href: "/formassembly-alternative" },
				{ title: "Typeform", href: "/typeform-alternative" },
				{ title: "Jotform", href: "/jotform-alternative" },
				{ title: "Wufoo", href: "/wufoo-alternative" },
				{ title: "SurveyMonkey", href: "/surveymonkey-alternative" }
			]
		},
		{
			category: "Features",
			hideOnMobile: false,
			links: [
				{
					title: "Conditional logic",
					href: "/help/features/conditional-logic"
				},
				{ title: "Salesforce forms", href: "/salesforce-forms" },
				{ title: "HubSpot forms", href: "/hubspot-forms" },
				{ title: "Zendesk ticket forms", href: "/zendesk-ticket-forms" },
				{ title: "Email forms", href: "/email-forms" },
				{ title: "Integrations", href: "/addons" },
				{ title: "Form fields", href: "/form-fields" }
			]
		},
		{
			category: "Resources",
			hideOnMobile: false,
			links: [
				{ title: "Help center", href: "/help" },
				{ title: "Blog", href: "/blog" },
				{ title: "Developer API", href: "/help/developers/api-docs-v2" },
				{ title: "GDPR", href: "/help/others/gdpr-compliant-forms" },
				{ title: "Status", href: "https://status.formcrafts.com" },
				{ title: "Report abuse", href: PUBLIC_APP_URL + "/report-abuse" },
				{ title: "Contact us", href: "/help/contact" }
			]
		},
		{
			category: "Company",
			hideOnMobile: false,
			links: [
				{ title: "About us", href: "/about" },
				{ title: "Nonprofit", href: "/nonprofit" },
				{ title: "Case studies", href: "/case-studies" },
				{ title: "Security", href: "/security" },
				{ title: "Terms and privacy", href: "/terms" }
			]
		}
	];

	let mobileNav = false;
	let fixedHeader = Boolean($page.data?.fixedHeader);
	let widePage = Boolean($page.data?.widePage);
	let seamlessHeader = Boolean($page.data?.seamlessHeader);
	let seamlessMobile = Boolean($page.data?.seamlessMobile);

	$: {
		if (browser) {
			if (mobileNav) {
				document.body.style.overflow = "hidden";
			} else {
				document.body.style.overflow = "";
			}
		}
	}

	onMount(() => {
		if (data.source) {
			if (!localStorage.getItem("fc_source")) {
				localStorage.setItem("fc_source", data.source);
			}
		}
		const document_referrer = document.referrer;
		const local_source = localStorage.getItem("fc_source");
		if (!local_source) {
			if (document_referrer && document_referrer !== "") {
				const currentPath = window?.location?.pathname?.split("/")[1] || "";
				try {
					const url = new URL(document_referrer);
					if (url.hostname !== window.location.hostname) {
						let new_source = url.hostname.replace("www.", "").split(".")[0];
						if (currentPath) {
							new_source = `${new_source}-${currentPath}`;
						}
						localStorage.setItem("fc_source", new_source);
					}
				} catch (e) {
					console.error("Failed to parse referrer URL:", document_referrer, e);
				}
			}
		}
		const source = localStorage.getItem("fc_source");
		if (source) {
			const signupLinks = document.querySelectorAll("a[href*='/signup']");
			signupLinks.forEach((link) => {
				try {
					const href = link.getAttribute("href") as string;
					const url = new URL(href, window.location.origin);
					url.searchParams.set("source", source);
					link.setAttribute("href", url.toString());
				} catch (e) {
					console.error("Failed to process link:", link, e);
				}
			});
		}
	});
</script>

<header
	class:mobile-nav="{mobileNav}"
	class:fixed-header="{fixedHeader}"
	class:seamless-header="{seamlessHeader}"
	class="h-14 border-b transition-[top] duration-200">
	<div
		class="flex flex-row items-center justify-between h-full header-cover flex-nowrap">
		<a href="/">
			<img
				src="{LogoPng}"
				width="504"
				height="79"
				alt="Formcrafts - a form and survey platform for Salesforce, HubSpot, etc"
				class="w-24 md:w-28" />
		</a>
		<div class="-mr-3 md:hidden">
			<Hamburger bind:open="{mobileNav}" align="right" />
		</div>
		<div
			class="flex-col {mobileNav
				? 'flex fixed left-0 bottom-0 w-screen top-14 text-lg flex-col'
				: 'hidden'} md:flex">
			<nav
				class="relative justify-center w-full h-full overflow-y-auto text-center bg-white md:overflow-visible md:w-auto overscroll-contain py-base md:py-0 md:bg-transparent">
				<ol
					class="flex flex-col items-end md:items-center md:flex-row md:text-gray-500">
					{#each header as item (item.link)}
						{@const active = data.currentPath === item.link}
						<li class="header-link" class:active="{active}">
							<div class="header-link-div">
								<a
									class:active="{active}"
									class="flex py-2 px-base md:py-3 md:px-3"
									href="{item.link}">{item.category}</a>
								{#if item.links.length}
									<ol class="py-2 sub-menu px-base md:p-0">
										{#each item.links as link}
											<li class="p-0 m-0 text-left">
												<a
													class="whitespace-nowrap text-left md:px-3 py-1.5 md:py-2 hover:bg-neutral-150 rounded flex items-center text-sm"
													class:text-theme-600="{data.currentPathFull ===
														link.path}"
													href="{link.path}">
													<div
														class="w-6 h-6 mr-1.5 p-1 inline-block rounded-full {data.currentPathFull ===
														link.path
															? 'bg-theme-100'
															: ''}">
														<img
															width="32"
															height="32"
															alt="{link.label} illustration"
															src="{link.icon}"
															loading="lazy" />
													</div>
													{link.label}
												</a>
											</li>
										{/each}
									</ol>
								{/if}
							</div>
						</li>
					{/each}
					<li class="header-link">
						<a
							class="flex items-center gap-1 py-2 px-base md:py-3 md:px-3"
							href="{PUBLIC_APP_URL}/login?maybe=true">
							Login
						</a>
					</li>
					<li class="header-link">
						<a
							class="flex items-center gap-1 py-2 px-base md:py-3 md:px-0 md:ml-2 group"
							href="{PUBLIC_APP_URL}/signup">
							<div
								class="inline-flex items-center md:bg-gray-800 md:group-hover:bg-gray-700 md:text-gray-100 rounded-full md:px-3 py-1 relative group-hover:md:pr-6 transition-[padding] duration-200 overflow-hidden">
								Signup
								<div
									class="absolute hidden px-1 transition-all duration-300 translate-x-6 md:flex right-2 group-hover:right-1 group-hover:translate-x-0">
									→
								</div>
							</div>
						</a>
					</li>
				</ol>
			</nav>
		</div>
	</div>
</header>
<div
	class:fixed-header="{fixedHeader}"
	class:seamless-mobile="{seamlessMobile}"
	class:seamless-header="{seamlessHeader}"
	class:wide-page="{widePage}"
	class="flex flex-col justify-between min-h-screen mx-auto main-content">
	<slot />
</div>

<footer class="relative mt-8 overflow-hidden text-center md:mt-32">
	<div class="w-full text-sm bg-gray-800">
		<a
			href="{PUBLIC_APP_URL}/signup"
			class="block w-full py-3 italic text-gray-200 hover:text-gray-50"
			style="-webkit-text-stroke: .2px #1f2937; font-size: 13px">
			Minimal, fast, and powerful. Try now.
		</a>
	</div>
	<div class="relative bg-white py-14">
		<div
			class="flex flex-col items-stretch justify-between w-full gap-8 mx-auto px-base md:px-10 lg:px-12 md:flex-row md:gap-4 max-w-7xl">
			<div class="flex flex-col items-start justify-start gap-2 w-60 lg:w-80">
				<div class="rounded-full h-0.5 w-5 bg-gray-800 mb-2"></div>
				<a href="/">
					<img
						src="{LogoPng}"
						width="504"
						height="79"
						alt="Formcrafts - a form and survey platform for Salesforce, HubSpot, etc"
						class="w-24 mt-0.5" />
				</a>
				<p class="mt-2 text-xs leading-relaxed text-left text-gray-500">
					Subtle Web Inc,<br />
					225 Railway St E,<br />
					T4C 2C3, Cochrane AB
				</p>
				<div class="flex flex-col gap-6 mt-2">
					<div class="flex flex-row gap-1 flex-nowrap">
						<a
							href="https://appexchange.salesforce.com/appxListingDetail?listingId=a0N4V00000DZ6McUAL"
							class="footer-partner-logo"
							target="_blank">
							<img
								src="{SalesforcePartner}"
								loading="lazy"
								width="446"
								height="474"
								alt="Salesforce AppExchange partner logo"
								class="w-auto h-12" />
						</a>
						<a
							href="https://ecosystem.hubspot.com/marketplace/apps/formcrafts-230865"
							class="py-1.5 px-2 h-12 rounded footer-partner-logo"
							target="_blank">
							<img
								src="{HubSpotPartner}"
								loading="lazy"
								width="542"
								height="222"
								alt="HubSpot app partner logo"
								class="w-auto h-full" />
						</a>
					</div>
				</div>
			</div>
			<div
				class="flex flex-row flex-wrap justify-between flex-1 w-auto max-w-4xl min-w-0 text-left text-gray-600 gap-y-6 footer-text lg:flex-nowrap md:gap-y-12 sm:text-gray-500">
				{#each footer as group}
					<div
						class="flex-col items-stretch w-full xs:w-1/3 lg:w-auto pr-12 {group.hideOnMobile
							? 'hidden sm:flex'
							: 'flex'}">
						<div class="mb-1 font-semibold text-gray-700">
							{group.category}
						</div>
						{#each group.links as link}
							<a class="footer-link" href="{link.href}">{link.title}</a>
						{/each}
					</div>
				{/each}
			</div>
		</div>
	</div>
</footer>
